import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-avatar-group p-component'
};

export default BaseStyle.extend({
    name: 'avatargroup',
    classes
});
